import React from 'react';

interface LegalDocumentsSectionProps {
    project: any;
    getImageUrl: (url: string) => string;
    setZoomedImage: (url: string | null) => void;
}

const LegalDocumentsSection: React.FC<LegalDocumentsSectionProps> = ({
    project,
    getImageUrl,
    setZoomedImage
}) => {
    const hasDocuments = project.legalDocuments && project.legalDocuments.some((doc: any) => doc.image);
    if (!hasDocuments) return null;

    const validDocuments = project.legalDocuments.filter((doc: any) => doc.image);

    return (
        <div id="legal-documents" className="card border border-gray-200 shadow-sm rounded-2xl mb-6 scroll-mt-32">
            <div className="bg-white py-6 px-6 md:px-8 border-b border-gray-200 flex justify-between items-center flex-wrap gap-2">
                <h4 className="text-xl md:text-2xl mb-0 font-bold text-black"><i className="fa-solid fa-file-contract text-primary mr-2"></i>Legal Documents</h4>
                <ul className="nav flex flex-wrap gap-2 gallery-pills" id="legalDocTab" role="tablist">
                    {validDocuments.map((doc: any, idx: number) => (
                        <li className="" role="presentation" key={idx}>
                            <button
                                className={`px-6 py-2 font-bold text-black hover:text-black transition-colors btn-sm rounded-full text-[13px] md:text-[14px] ${idx === 0 ? 'active border-black' : 'border-gray-100'}`}
                                id={`doc-${idx}-tab`}
                                data-bs-toggle="pill"
                                data-bs-target={`#doc-${idx}`}
                                type="button"
                                role="tab"
                            >
                                {doc.title}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="p-0 text-center bg-white">
                <div className="tab-content" id="legalDocTabContent">
                    {validDocuments.map((doc: any, idx: number) => (
                        <div
                            className={`tab-pane fade ${idx === 0 ? 'show active' : 'hidden'}`}
                            id={`doc-${idx}`}
                            role="tabpanel"
                            key={idx}
                        >
                            <div className="legal-doc-preview-container mx-auto p-0" style={{ maxWidth: '1000px', margin: '0 auto' }}>
                                <img
                                    src={getImageUrl(doc.image)}
                                    className="w-full h-auto cursor-zoom-in"
                                    alt={doc.title}
                                    style={{ maxHeight: '800px', objectFit: 'contain' }}
                                    onClick={() => setZoomedImage(doc.image)}
                                    onError={(e) => {
                                        const target = e.target as HTMLImageElement;
                                        target.src = '/assets/img/document-placeholder.png';
                                        target.style.opacity = '0.5';
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LegalDocumentsSection;
